// Tipos de actividad predefinidos. El usuario puede añadir otros "al vuelo":
// cualquier activity_type guardado en una actividad se suma a la lista.
export const DEFAULT_ACTIVITY_TYPES = ["Organización", "Instalaciones", "Infraestructuras", "Trabajos"];

export const activityTypeColor = (type) => {
  const t = (type || "").toLowerCase();
  if (t === "organización" || t === "organizacion") return "bg-rose-100 text-rose-800 border-rose-200";
  if (t === "instalaciones") return "bg-sky-100 text-sky-800 border-sky-200";
  if (t === "infraestructuras") return "bg-amber-100 text-amber-800 border-amber-200";
  if (t === "trabajos") return "bg-emerald-100 text-emerald-800 border-emerald-200";
  return "bg-slate-100 text-slate-700 border-slate-200";
};

export const mergeActivityTypes = (activities) => {
  const set = new Set(DEFAULT_ACTIVITY_TYPES);
  (activities || []).forEach((a) => {
    const t = (a.activity_type || "").trim();
    if (t) set.add(t);
  });
  return Array.from(set).sort((x, y) => x.localeCompare(y, "es", { sensitivity: "base" }));
};
